import React, { ReactNode } from "react"

import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

interface ImageOverlayViewProps {
  url?: string
  content?: ReactNode
  title?: string
  onClose: () => void
}

export const ImageOverlayView = React.memo(
  ({ url, content, title, onClose }: ImageOverlayViewProps) => {
    return (
      <OverlayWrapper
        id="image-overlay"
        className="image-overlay"
        classNamePrefix="image-overlay"
        mobileFullscreen
        desktopFullscreen
      >
        <OverlayHeader.Container responsive={false}>
          {title ? <OverlayHeader.Title>{title}</OverlayHeader.Title> : null}
          <OverlayHeader.CloseButton onClick={onClose} />
        </OverlayHeader.Container>
        <div className="image-overlay__body">
          <div className="image-overlay__content">
            {url ? <img src={url} alt="" /> : content}
          </div>
        </div>
      </OverlayWrapper>
    )
  }
)
